export default {
    label_task:{
        en:"Crops",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Crop",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Crop",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Crop",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_code:{
        en:"Code",
        bn:"প্রিফিক্স"
    },
    label_replica :{
        en:"Replica",
        bn:"কর্মচারী আইডি"
    },
    label_initial_plants :{
        en:"Initial Plants",
        bn:"কর্মচারী আইডি"
    },
}